/**
 * Enter commits and returns focus to the canvas; Escape restores the previous text.
 * Without this, focus stays in the field and later shortcuts type into it.
 */
export function fieldKeys(revertTo: string) {
  return (event: KeyboardEvent & { currentTarget: HTMLInputElement }): void => {
    if (event.key !== 'Enter' && event.key !== 'Escape') return;
    event.stopPropagation();
    if (event.key === 'Escape') event.currentTarget.value = revertTo;
    event.currentTarget.blur();
  };
}
